import {FC} from 'react'

import {usePreferences} from '@/components/context/Preferences'
import {getPricingContent} from '@/content/pricing'
import {Trans, useTranslation} from '@/i18n'
import {Jurisdiction} from '@/utils/countries/constants'
import {useLanguage} from '@/utils/i18n/language'
import {getFormattedPriceForExtraItems} from '@/utils/pricing'

import {FormTooltip} from './FormTooltip'

type PriceWarningTooltipProps = {
  country: Jurisdiction
}

export const PriceWarningTooltip: FC<React.PropsWithChildren<PriceWarningTooltipProps>> = ({
  country,
}) => {
  const language = useLanguage()
  const {t} = useTranslation()

  const {currency} = usePreferences()
  const {usWarningTooltipText} = getPricingContent().calculator

  const tooltipText =
    country === Jurisdiction.US ? (
      t(usWarningTooltipText)
    ) : (
      <Trans
        i18nKey={`pricing-${country.toLowerCase()}-warning-tooltip-text`}
        values={{price: getFormattedPriceForExtraItems(country, currency, language)}}
      />
    )

  return (
    <>
      <span className="warning">
        <FormTooltip tooltipText={tooltipText} position="center" />
      </span>

      <style jsx>{`
        .warning {
          display: flex;
          align-items: center;
        }
      `}</style>
    </>
  )
}
